/**
 * Check device for redirect to Mobile Version off APP (TEMPORARY)
 */
export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
